module.exports = __webpack_public_path__ + "img/ic_linkedin.746524b7.svg";